import {
  Observer,
} from '@livelybone/simple-observer'
import {
  Storage,
} from '@livelybone/storage'

/**
 * auth_token
 */
class AuthToken {
  static setToken(val, expired) {
    const {
      token = '', token_expire = '',
    } = val || {}
    const oldToken = this.getT()
    this.storage.set(this.key, token)
    this.storage.set(this.expireKey, token_expire)
    console.log(token, '===', expired, 'this.next')
    if (this.next && token !== oldToken) this.next(token, expired)
  }

  static getToken() {
    const token = this.getT()
    if (!token) return token
    const now = Date.now()
    const expireTime = +this.storage.get(this.expireKey) * 1000
    if (now > expireTime) {
      this.setToken('', true)
      return ''
    }
    return token
  }

  static getT() {
    // console.log(window !)
    // console.log(this.key, '::::', this.storage.get(this.key), ':::wuyu')
    return this.storage.get(this.key)
  }
}

AuthToken.key = 'AUTH_TOKEN'
AuthToken.expireKey = 'EXPIRE'
AuthToken.storage = typeof window !== 'undefined' ? new Storage(true) : {
  addHandler: () => '',
}
AuthToken.tokenChange = new Observer((next) => {
  AuthToken.next = next
})

export default AuthToken